import { FC, useMemo } from 'react'
import {
  AtendimentoEstado,
  ButtonType,
  IconPaths,
  showError,
} from '../../../../../../../_metronic/helpers'
import { AtendimentoView } from '../../../../atendimento/core/_models'
import { useAuth } from '../../../../../auth'
import { isVinculoMedico } from 'app/modules/auth/core/vinculos'
import { AtendimentoMedicoInfo } from '../AtendimentoInfo/AtendimentoInfo'
import { Button, FetchState, useModal } from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'
import { updateAtendimento } from '../../core/_requests'
import { rotaDaChamada } from '../../../chamada-ativa/core/_models'

type Props = {
  /** Presente quando este atendimento já tem chamada ativa nesta aba: volta a ela em vez de abrir nova aba. */
  onRetomarChamada?: () => void
}

/**
 * Detalhes do atendimento na fila, com "Atender Paciente" (abre a sala e o teleatendimento).
 * Interconsulta não passa por aqui: a lista leva direto à tela do parecer.
 */
export const IniciarAtendimentoModal: FC<Props> = ({ onRetomarChamada }) => {
  const { fetchStates, closeModal, refetch } = useModal()
  const { currentUser } = useAuth()
  const { t } = useT()

  const { data: atendimento } = (fetchStates['atendimento'] || {}) as FetchState<AtendimentoView>

  const redirectAtendimentoURL = () =>
    window.open(atendimento?.urlAtendimento, '_blank', 'noreferrer')

  const iniciarAtendimento = async () => {
    // Abrir nova aba entraria no canal com o mesmo usuário e derrubaria a conexão desta (conflito de UID).
    if (onRetomarChamada) {
      closeModal()
      onRetomarChamada()
      return
    }
    const newWindow = window.open('', '_blank')

    try {
      await updateAtendimento(Number(atendimento?.id), {
        estado: AtendimentoEstado.EmAtendimento,
        responsavel: Number(currentUser?.pessoa?.id),
        salaVideo: true,
      })

      newWindow?.location.replace(rotaDaChamada(Number(atendimento?.id)))
      closeModal()
    } catch (error) {
      newWindow?.close()
      showError(error)
    }
  }

  const showUrl = useMemo(() => {
    return (
      atendimento?.urlAtendimento &&
      (atendimento?.estado?.id === AtendimentoEstado.Aguardando ||
        atendimento?.estado?.id === AtendimentoEstado.EmAtendimento)
    )
  }, [atendimento])

  const funcionarios = currentUser?.vinculos?.filter(
    (vinculo) =>
      vinculo.ativo &&
      vinculo.funcionario &&
      vinculo.empresa?.id === atendimento?.paciente?.empresa?.id
  )

  const isMedico = funcionarios?.some(isVinculoMedico) || false

  return (
    <>
      <AtendimentoMedicoInfo atendimento={atendimento} onAtualizar={() => refetch('atendimento')} />
      <div className='separator my-4' />

      {isMedico && showUrl && (
        <Button
          className='btn-primary w-100 mb-3'
          onClick={redirectAtendimentoURL}
          icon={IconPaths.Record}
        >
          Link da Consulta
        </Button>
      )}

      <div className='d-flex gap-3'>
        <Button type={ButtonType.Reset} className='btn-secondary flex-equal' onClick={closeModal}>
          {t('common.cancel')}
        </Button>

        {isMedico ? (
          <Button
            className='btn-primary flex-equal'
            onClick={iniciarAtendimento}
            icon={IconPaths.Estetoscopio}
          >
            Atender Paciente
          </Button>
        ) : showUrl ? (
          <Button
            className='btn-primary flex-equal'
            onClick={redirectAtendimentoURL}
            icon={IconPaths.Record}
          >
            Link da Consulta
          </Button>
        ) : null}
      </div>
    </>
  )
}
